import Layout from '../../layout';

const EmptyPage = () => <Layout></Layout>;

export default EmptyPage;
